import ApiService from '@/shared/services/api.service';
import Errors from '@/shared/error/errors';

const DO_FETCH = 'doFetch';
const GET_NOTIFICATION_TEMPLATE = 'getNotificationTemplate';
const UPDATE_NOTIFICATION_TEMPLATE = 'updateNotificationTemplate';

const FETCH_SUCCESS = 'fetchSuccess';
const SET_CURRENT_PAGE = 'setCurrentPage';
const SET_FILTERS = 'setFilters';

const state = {
    rows: [],
    total: 0,
    storeFilters: {},
    currentPage: 1,
};

const getters = {
    rows: (state) => state.rows,
    total: (state) => state.total,
    filters: (state) => state.storeFilters,
    currentPage: (state) => state.currentPage,
};

const actions = {
    [DO_FETCH](context, params) {
        context.commit('shared/activateLoading', 'notifications/templates/getNotificationsTemplates', { root: true });
        return ApiService.query('notifications/templates', { params: { ...params, pagination: true } })
            .then(({ data }) => {
                context.commit(FETCH_SUCCESS, {
                    rows: data.data,
                    total: data.pagination.total,
                });
            })
            .catch((error) => {
                Errors.handle(error);
            })
            .finally(() => {
                context.commit('shared/deactivateLoading', 'notifications/templates/getNotificationsTemplates', { root: true });
            });
    },
    [GET_NOTIFICATION_TEMPLATE](context, id) {
        return new Promise((resolve, reject) => {
            ApiService.get(`notifications/templates/${id}`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(( error ) => {
                    reject(error);
                });
        });
    },
    [UPDATE_NOTIFICATION_TEMPLATE](context, payload) {
        context.commit('shared/activateLoading', 'notifications/templates/updateNotificationTemplate', { root: true });
        return new Promise((resolve, reject) => {
            ApiService.patch(`notifications/templates/${payload.id}`, {
                title: payload.title,
                subject: payload.subject,
                message: payload.message,
            })
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(( error ) => {
                    reject(error);
                })
                .finally(() => {
                    context.commit('shared/deactivateLoading', 'notifications/templates/updateNotificationTemplate', { root: true });
                });
        });
    },
};

const mutations = {
    [FETCH_SUCCESS](state, { rows, total }) {
        state.rows = rows;
        state.total = total;
    },
    [SET_CURRENT_PAGE](state, page) {
        state.currentPage = page;
    },
    [SET_FILTERS](state, { key, value }) {
        state.storeFilters[key] = value;
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};
